import { ROUTE_PATHS } from '@constants/routes';
import { Box, Stack } from '@mui/material';
import { alpha, type Theme } from '@mui/material/styles';
import { useAppSelector } from '@store/hooks';
import AppTheme from '@theme/theme';
import React, { useEffect, useState } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import AppNavbar from './Navbar/AppNavbar';
import SideBar from './Sidebar/Sidebar';

interface MainLayoutProps {
  children?: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = () => {
  const authState = useAppSelector((state) => state.auth);
  const navigate = useNavigate();

  const isUsersPage = useMatch(ROUTE_PATHS.USERS);
  const isServerConfigPage = useMatch(ROUTE_PATHS.SERVER_CONFIG);

  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    if (!authState.isAuthenticated) {
      navigate(ROUTE_PATHS.LOGIN);
    } else if (isUsersPage || isServerConfigPage) {
      console.log(authState.user?.role);
      if ((authState.user?.role ?? 'user') == 'user') navigate(ROUTE_PATHS.HOME);
    }
  }, [authState, isServerConfigPage, isUsersPage, navigate]);

  return authState.isAuthenticated ? (
    <AppTheme disableCustomInputs={true}>
      <Box sx={mainContainerStyles}>
        <SideBar />
        <AppNavbar toggleDrawer={toggleDrawer} open={isDrawerOpen} />
        <Box component="main" sx={(theme) => mainContentStyles(theme)}>
          <Stack spacing={2} sx={contentStackStyles}>
            <Outlet />
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  ) : null;
};


const mainContainerStyles = {
  display: 'flex',
  width: '100%',
  height: '100vh',
};

const mainContentStyles = (theme: Theme) => ({
  flexGrow: 1,
  backgroundColor: theme.cssVariables
    ? `rgba(${theme.palette.background.default} / 1)`
    : alpha(theme.palette.background.default, 1),
  overflow: 'auto',
  alignItems: 'start',
  justifyContent: 'center',
  display: 'flex',
});

const contentStackStyles = {
  alignItems: 'start',
  justifyContent: 'start',
  mx: 3,
  pb: 5,
  mt: { xs: 8, md: 8, lg: 0 },
  maxWidth: { xs: '100%', md: '900px', lg: '1100px', xl: '1500px' },
  minWidth: { xs: '90%', md: '700px', lg: '800px', xl: '1000px' },
  width: '100%'
};

export default MainLayout;
